import { nanoid } from 'nanoid';
import { POLL_CHOICE_CONJOINT as QuestionType } from '../../../../../poll';
import { assignProperties } from '../../../../schemaUtils';
import { config } from './ChoiceConjoint.config';

export function generateQuestion(_: unknown, overrides: Partial<QuestionType['data']> = {}): QuestionType {
  return {
    id: nanoid(10),
    data: assignProperties<QuestionType['data']>(
      {
        type: config.name,
        text: '',
        requiresAnswer: true,
        hasTimer: false,
        logicRules: [],
        goToRules: [],
        hasNotApplicable: false,
        attributes: [
          {
            id: nanoid(10),
            name: '',
            levels: [
              {
                id: nanoid(10),
                name: '',
              },
            ],
          },
        ],
        cardsOnScreen: [
          {
            name: '',
          },
        ],
        numberOfScreens: 1,
        exclusiveLevels: {},
      },
      overrides,
    ),
  };
}
